// import React, { useState, useEffect } from 'react';
// import { FaSearch, FaSync, FaStore, FaMapMarkerAlt, FaUser, FaEnvelope, FaIdBadge, FaPhone, FaClock } from 'react-icons/fa';
// import { useLoader } from '../../../../context/LoaderProvider';

// // ============================================
// // STYLES
// // ============================================
// const styles = {
//     container: {
//         maxHeight:"70vh",
//         overflow:"auto",
//         scrollbarWidth:"none",
//         fontFamily: 'Segoe UI, sans-serif',

//     },
//     statsGrid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(4, 1fr)',
//         gap: '16px',
//         marginBottom: '24px'
//     },
//     statCard: {
//         background: 'white',
//         borderRadius: '12px',
//         padding: '20px 24px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         transition: 'all 0.3s ease'
//     },
//     statLabel: {
//         fontSize: '13px',
//         color: '#94a3b8',
//         fontWeight: '500',
//         marginBottom: '6px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px'
//     },
//     statValue: {
//         fontSize: '28px',
//         fontWeight: '700',
//         color: '#1e293b'
//     },
//     statSub: {
//         fontSize: '12px',
//         color: '#94a3b8',
//         marginTop: '4px'
//     },
//     filtersBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//         background: 'white',
//         padding: '12px 20px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         margin: '10px 0px',
//         flexWrap: 'wrap'
//     },
//     searchWrapper: {
//         display: 'flex',
//         alignItems: 'center',
//         flex: '1',
//         minWidth: '200px',
//         background: '#f8fafc',
//         borderRadius: '8px',
//         padding: '0 12px',
//         border: '1px solid #e2e8f0',
//         transition: 'all 0.2s ease'
//     },
//     searchInput: {
//         border: 'none',
//         background: 'transparent',
//         padding: '10px 8px',
//         fontSize: '14px',
//         outline: 'none',
//         flex: '1',
//         color: '#334155'
//     },
//     searchSelect: {
//         padding: '8px 12px',
//         border: 'none',
//         background: 'transparent',
//         fontSize: '13px',
//         color: '#334155',
//         outline: 'none',
//         cursor: 'pointer',
//         borderRight: '1px solid #e2e8f0',
//         minWidth: '120px'
//     },
//     actionBtn: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         padding: '10px 18px',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '14px',
//         fontWeight: '500',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease'
//     },
//     tableWrapper: {
//         background: 'white',
//         borderRadius: '12px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         overflow: 'auto',
//         maxHeight: '70vh',
//         scrollbarWidth: 'thin'
//     },
//     table: {
//         width: '100%',
//         borderCollapse: 'collapse',
//         fontSize: '14px',
//         minWidth: '1000px'
//     },
//     th: {
//         background: '#f8fafc',
//         color: '#475569',
//         fontWeight: '600',
//         padding: '14px 16px',
//         textAlign: 'left',
//         borderBottom: '2px solid #e2e8f0',
//         position: 'sticky',
//         top: 0,
//         zIndex: 10,
//         background: '#f8fafc',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '14px 16px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#334155',
//         verticalAlign: 'middle'
//     },
//     statusBadge: {
//         display: 'inline-block',
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '600',
//         background: '#dcfce7',
//         color: '#15803d'
//     },
//     onlineBadge: {
//         display: 'inline-block',
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '600',
//         background: '#dcfce7',
//         color: '#15803d'
//     },
//     offlineBadge: {
//         display: 'inline-block',
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '600',
//         background: '#fee2e2',
//         color: '#991b1b'
//     },
//     emptyState: {
//         textAlign: 'center',
//         padding: '60px 20px',
//         color: '#94a3b8'
//     },
//     loadingOverlay: {
//         textAlign: 'center',
//         padding: '40px 20px',
//         color: '#64748b'
//     },
//     restaurantCard: {
//         background: 'white',
//         borderRadius: '12px',
//         padding: '16px 20px',
//         border: '1px solid #f0f0f0',
//         transition: 'all 0.3s ease',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         marginBottom: '12px'
//     },
//     restaurantInfo: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '4px'
//     },
//     restaurantName: {
//         fontSize: '16px',
//         fontWeight: '600',
//         color: '#1e293b'
//     },
//     restaurantDetail: {
//         fontSize: '13px',
//         color: '#64748b',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px'
//     },
//     restaurantActions: {
//         display: 'flex',
//         gap: '8px'
//     },
//     viewBtn: {
//         padding: '6px 16px',
//         border: 'none',
//         borderRadius: '6px',
//         background: '#e66d33',
//         color: 'white',
//         cursor: 'pointer',
//         fontSize: '13px',
//         fontWeight: '500',
//         transition: 'all 0.2s ease'
//     }
// };

// // ============================================
// // DUMMY DATA
// // ============================================
// const dummyRestaurants = [
//     {
//         id: 1,
//         vendorId: 'VEN-001',
//         vendorName: 'Maamaas Houses',
//         restaurantName: 'Maamaas Houses - KPHB',
//         email: 'maamaas@example.com',
//         phone: '+91 9876543210',
//         location: 'KPHB, Hyderabad',
//         city: 'Hyderabad',
//         area: 'KPHB',
//         online: true,
//         verified: true,
//         rating: 4.5,
//         totalOrders: 1250,
//         joinedDate: '2024-01-15'
//     },
//     {
//         id: 2,
//         vendorId: 'VEN-002',
//         vendorName: 'Spice Garden',
//         restaurantName: 'Spice Garden - Kukatpally',
//         email: 'spicegarden@example.com',
//         phone: '+91 8765432109',
//         location: 'Kukatpally, Hyderabad',
//         city: 'Hyderabad',
//         area: 'Kukatpally',
//         online: true,
//         verified: true,
//         rating: 4.2,
//         totalOrders: 980,
//         joinedDate: '2024-02-20'
//     },
//     {
//         id: 3,
//         vendorId: 'VEN-003',
//         vendorName: 'Taste of Punjab',
//         restaurantName: 'Taste of Punjab - SR Nagar',
//         email: 'tasteofpunjab@example.com',
//         phone: '+91 7654321098',
//         location: 'SR Nagar, Hyderabad',
//         city: 'Hyderabad',
//         area: 'SR Nagar',
//         online: true,
//         verified: true,
//         rating: 4.7,
//         totalOrders: 2100,
//         joinedDate: '2023-11-10'
//     },
//     {
//         id: 4,
//         vendorId: 'VEN-004',
//         vendorName: 'Coastal Delights',
//         restaurantName: 'Coastal Delights - Gachibowli',
//         email: 'coastal@example.com',
//         phone: '+91 6543210987',
//         location: 'Gachibowli, Hyderabad',
//         city: 'Hyderabad',
//         area: 'Gachibowli',
//         online: true,
//         verified: true,
//         rating: 4.0,
//         totalOrders: 750,
//         joinedDate: '2024-03-05'
//     },
//     {
//         id: 5,
//         vendorId: 'VEN-005',
//         vendorName: 'Mumbai Mirch',
//         restaurantName: 'Mumbai Mirch - Jubilee Hills',
//         email: 'mumbaimirch@example.com',
//         phone: '+91 5432109876',
//         location: 'Jubilee Hills, Hyderabad',
//         city: 'Hyderabad',
//         area: 'Jubilee Hills',
//         online: true,
//         verified: true,
//         rating: 4.8,
//         totalOrders: 3200,
//         joinedDate: '2023-09-01'
//     },
//     {
//         id: 6,
//         vendorId: 'VEN-006',
//         vendorName: 'Royal Dine',
//         restaurantName: 'Royal Dine - Banjara Hills',
//         email: 'royaldine@example.com',
//         phone: '+91 4321098765',
//         location: 'Banjara Hills, Hyderabad',
//         city: 'Hyderabad',
//         area: 'Banjara Hills',
//         online: true,
//         verified: true,
//         rating: 4.3,
//         totalOrders: 1500,
//         joinedDate: '2024-01-28'
//     }
// ];

// // ============================================
// // COMPONENT
// // ============================================
// const OnlineRestaurents = () => {
//     const { showLoader, hideLoader } = useLoader();
//     const [restaurants, setRestaurants] = useState([]);
//     const [filteredRestaurants, setFilteredRestaurants] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [searchType, setSearchType] = useState('all');
//     const [error, setError] = useState(null);

//     // Search options
//     const searchOptions = [
//         { value: 'all', label: 'All Fields' },
//         { value: 'restaurantName', label: 'Restaurant Name' },
//         { value: 'vendorName', label: 'Vendor Name' },
//         { value: 'vendorId', label: 'Vendor ID' },
//         { value: 'area', label: 'Location/Area' }
//     ];

//     // ─── Fetch Restaurants ──────────────────────────────────────
//     useEffect(() => {
//         fetchRestaurants();
//     }, []);

//     const fetchRestaurants = async () => {
//         try {
//             setLoading(true);
//             setError(null);
//             showLoader();

//             // TODO: Replace with actual API call
//             // const token = localStorage.getItem('authToken');
//             // const response = await fetch('your-api-endpoint/online-restaurants', {
//             //     headers: { Authorization: `Bearer ${token}` }
//             // });
//             // const data = await response.json();

//             // Using dummy data for now
//             setTimeout(() => {
//                 // Filter only online restaurants
//                 const onlineRestaurants = dummyRestaurants.filter(r => r.online === true);
//                 setRestaurants(onlineRestaurants);
//                 setFilteredRestaurants(onlineRestaurants);
//                 setLoading(false);
//                 hideLoader();
//             }, 500);

//         } catch (error) {
//             console.error('Error fetching restaurants:', error);
//             setError(error.message || 'Failed to load restaurants');
//             setLoading(false);
//             hideLoader();
//         }
//     };

//     // ─── Filter Restaurants ─────────────────────────────────────
//     useEffect(() => {
//         if (!searchQuery.trim()) {
//             setFilteredRestaurants(restaurants);
//             return;
//         }

//         const query = searchQuery.toLowerCase().trim();
//         let filtered = restaurants.filter(restaurant => {
//             switch (searchType) {
//                 case 'restaurantName':
//                     return restaurant.restaurantName.toLowerCase().includes(query);
//                 case 'vendorName':
//                     return restaurant.vendorName.toLowerCase().includes(query);
//                 case 'vendorId':
//                     return restaurant.vendorId.toLowerCase().includes(query);
//                 case 'area':
//                     return restaurant.area.toLowerCase().includes(query) ||
//                            restaurant.location.toLowerCase().includes(query);
//                 default:
//                     return restaurant.restaurantName.toLowerCase().includes(query) ||
//                            restaurant.vendorName.toLowerCase().includes(query) ||
//                            restaurant.vendorId.toLowerCase().includes(query) ||
//                            restaurant.area.toLowerCase().includes(query) ||
//                            restaurant.location.toLowerCase().includes(query) ||
//                            restaurant.city.toLowerCase().includes(query);
//             }
//         });

//         setFilteredRestaurants(filtered);
//     }, [searchQuery, searchType, restaurants]);

//     // ─── Stats ──────────────────────────────────────────────────
//     const totalRestaurants = filteredRestaurants.length;
//     const totalOrders = filteredRestaurants.reduce((sum, r) => sum + r.totalOrders, 0);
//     const avgRating = filteredRestaurants.length > 0 
//         ? (filteredRestaurants.reduce((sum, r) => sum + r.rating, 0) / filteredRestaurants.length).toFixed(1)
//         : 0;
//     const uniqueAreas = new Set(filteredRestaurants.map(r => r.area)).size;

//     // ─── Format Date ────────────────────────────────────────────
//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         return new Date(dateString).toLocaleDateString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         });
//     };

//     // ─── Render ──────────────────────────────────────────────────
//     if (loading) {
//         return (
//             <div style={styles.container}>
//                 <div style={styles.loadingOverlay}>
//                     <div className="spinner" style={{
//                         width: '40px',
//                         height: '40px',
//                         border: '4px solid #f3f4f6',
//                         borderTop: '4px solid #e66d33',
//                         borderRadius: '50%',
//                         animation: 'spin 1s linear infinite',
//                         margin: '0 auto 12px'
//                     }}></div>
//                     <p>Loading online restaurants...</p>
//                 </div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div style={styles.container}>
//                 <div style={styles.emptyState}>
//                     <p style={{ color: '#dc2626', fontWeight: '600' }}>⚠️ {error}</p>
//                     <button
//                         onClick={fetchRestaurants}
//                         style={{
//                             ...styles.actionBtn,
//                             background: '#e66d33',
//                             color: 'white',
//                             marginTop: '12px'
//                         }}
//                     >
//                         Try Again
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div style={styles.container}>
//             {/* ─── Dashboard Stats ────────────────────────────────── */}
//             {/* <div style={styles.statsGrid}>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Online Restaurants</div>
//                     <div style={styles.statValue}>{totalRestaurants}</div>
//                     <div style={styles.statSub}>Currently online</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Total Orders</div>
//                     <div style={styles.statValue}>{totalOrders.toLocaleString()}</div>
//                     <div style={styles.statSub}>Across all restaurants</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Average Rating</div>
//                     <div style={styles.statValue} style={{ color: '#f59e0b' }}>⭐ {avgRating}</div>
//                     <div style={styles.statSub}>Average customer rating</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Locations</div>
//                     <div style={styles.statValue} style={{ color: '#8b5cf6' }}>{uniqueAreas}</div>
//                     <div style={styles.statSub}>Unique areas</div>
//                 </div>
//             </div> */}

//             {/* ─── Filters Bar ────────────────────────────────────── */}
//             <div style={styles.filtersBar}>
//                 <div style={styles.searchWrapper}>
//                     <FaSearch color="#94a3b8" size={16} />
//                     <select
//                         value={searchType}
//                         onChange={(e) => setSearchType(e.target.value)}
//                         style={styles.searchSelect}
//                     >
//                         {searchOptions.map(option => (
//                             <option key={option.value} value={option.value}>
//                                 {option.label}
//                             </option>
//                         ))}
//                     </select>
//                     <input
//                         type="text"
//                         style={styles.searchInput}
//                         placeholder={`Search by ${searchOptions.find(o => o.value === searchType)?.label || 'All Fields'}...`}
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                     />
//                     {searchQuery && (
//                         <span 
//                             style={{ cursor: 'pointer', color: '#94a3b8', padding: '4px' }}
//                             onClick={() => setSearchQuery('')}
//                         >
//                             ✕
//                         </span>
//                     )}
//                 </div>

//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#f1f5f9',
//                         color: '#475569'
//                     }}
//                     onClick={() => {
//                         setSearchQuery('');
//                         setSearchType('all');
//                     }}
//                 >
//                     <FaSync size={14} /> Clear
//                 </button>

//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#e66d33',
//                         color: 'white'
//                     }}
//                     onClick={fetchRestaurants}
//                 >
//                     <FaSync size={14} /> Refresh
//                 </button>
//             </div>

//             {/* ─── Table ───────────────────────────────────────────── */}
//             <div style={styles.tableWrapper}>
//                 {filteredRestaurants.length === 0 ? (
//                     <div style={styles.emptyState}>
//                         <div style={{ fontSize: '48px', marginBottom: '12px' }}>🏪</div>
//                         <h3>No Online Restaurants Found</h3>
//                         <p>
//                             {restaurants.length === 0 
//                                 ? 'No restaurants are currently online.' 
//                                 : 'No restaurants match your search filters.'}
//                         </p>
//                     </div>
//                 ) : (
//                     <table style={styles.table}>
//                         <thead>
//                             <tr>
//                                 <th style={styles.th}>#</th>
//                                 <th style={styles.th}>Restaurant Name</th>
//                                 <th style={styles.th}>Vendor Name</th>
//                                 <th style={styles.th}>Vendor ID</th>
//                                 <th style={styles.th}>Email</th>
//                                 <th style={styles.th}>Phone</th>
//                                 <th style={styles.th}>Area / Location</th>
//                                 <th style={styles.th}>Rating</th>
//                                 <th style={styles.th}>Orders</th>
//                                 <th style={styles.th}>Status</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredRestaurants.map((restaurant, index) => (
//                                 <tr 
//                                     key={restaurant.id}
//                                     style={{
//                                         transition: 'background 0.2s ease',
//                                         borderBottom: '1px solid #f1f5f9'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.background = '#fef9f4'}
//                                     onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 >
//                                     <td style={styles.td}>{index + 1}</td>
//                                     <td style={{ ...styles.td, fontWeight: '600', color: '#1e293b' }}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                             <FaStore color="#e66d33" size={14} />
//                                             {restaurant.restaurantName}
//                                         </div>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                                             <FaUser size={12} color="#94a3b8" />
//                                             {restaurant.vendorName}
//                                         </div>
//                                     </td>
//                                     <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px', color: '#64748b' }}>
//                                         {restaurant.vendorId}
//                                     </td>
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                                             <FaEnvelope size={12} color="#94a3b8" />
//                                             {restaurant.email}
//                                         </div>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                                             <FaPhone size={12} color="#94a3b8" />
//                                             {restaurant.phone}
//                                         </div>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                                             <FaMapMarkerAlt size={12} color="#e66d33" />
//                                             {restaurant.area}
//                                             <span style={{ fontSize: '11px', color: '#94a3b8' }}>
//                                                 ({restaurant.city})
//                                             </span>
//                                         </div>
//                                     </td>
//                                     <td style={{ ...styles.td, fontWeight: '600', color: '#f59e0b' }}>
//                                         ⭐ {restaurant.rating}
//                                     </td>
//                                     <td style={styles.td}>
//                                         {restaurant.totalOrders.toLocaleString()}
//                                     </td>
//                                     <td style={styles.td}>
//                                         <span style={styles.onlineBadge}>
//                                             <span style={{ 
//                                                 display: 'inline-block', 
//                                                 width: '6px', 
//                                                 height: '6px', 
//                                                 borderRadius: '50%', 
//                                                 background: '#22c55e',
//                                                 marginRight: '6px',
//                                                 animation: 'pulse 1.5s ease-in-out infinite'
//                                             }}></span>
//                                             Online
//                                         </span>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             {/* ─── Footer Info ────────────────────────────────────── */}


//             {/* ─── Inline Styles ───────────────────────────────────── */}
//             <style>{`
//                 @keyframes spin {
//                     to { transform: rotate(360deg); }
//                 }
//                 @keyframes pulse {
//                     0% { opacity: 1; }
//                     50% { opacity: 0.4; }
//                     100% { opacity: 1; }
//                 }
//                 .spinner {
//                     width: 40px;
//                     height: 40px;
//                     border: 4px solid #f3f4f6;
//                     border-top: 4px solid #e66d33;
//                     border-radius: 50%;
//                     animation: spin 1s linear infinite;
//                     margin: 0 auto 12px;
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default OnlineRestaurents;







import React, { useState, useEffect } from 'react';
import { FaSearch, FaSync, FaStore, FaMapMarkerAlt, FaUser, FaEnvelope, FaIdBadge, FaPhone, FaClock, FaBuilding } from 'react-icons/fa';
import { useLoader } from '../../../../context/LoaderProvider';

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        maxHeight: "70vh",
        overflow: "auto",
        scrollbarWidth: "none",
        fontFamily: 'Segoe UI, sans-serif',
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginTop:"10px",
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
    },
    statLabel: {
        fontSize: '13px',
        color: '#94a3b8',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b'
    },
    statSub: {
        fontSize: '12px',
        color: '#94a3b8',
    },
    filtersBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',

        borderRadius: '12px',

        margin: '10px 0px',
        flexWrap: 'wrap'
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        minWidth: '200px',
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '0 12px',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease'
    },
    searchInput: {
        border: 'none',
        background: 'transparent',
        padding: '10px 8px',
        fontSize: '14px',
        outline: 'none',
        flex: '1',
        color: '#334155'
    },
    searchSelect: {
        padding: '8px 12px',
        border: 'none',
        background: 'transparent',
        fontSize: '13px',
        color: '#334155',
        outline: 'none',
        cursor: 'pointer',
        borderRight: '1px solid #e2e8f0',
        minWidth: '120px'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    tableWrapper: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        overflow: 'auto',
        maxHeight: '60vh',
        scrollbarWidth: 'thin'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
        minWidth: '1100px'
    },
    th: {
        background: "#e66d33",
        color: '#ffffff',
        fontWeight: '600',
        padding: '14px 16px',
        textAlign: 'left',
        borderBottom: '2px solid #e2e8f0',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '14px 16px',
        borderBottom: '1px solid #f1f5f9',
        color: '#334155',
        verticalAlign: 'middle'
    },
    onlineBadge: {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        background: '#dcfce7',
        color: '#15803d'
    },
    emptyState: {
        textAlign: 'center',
        padding: '60px 20px',
        color: '#94a3b8'
    },
    loadingOverlay: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#64748b'
    }
};

// ============================================
// API URL
// ============================================
const API_URL = "https://backend.maamaas.com/food/api/vendors/restaurent/online";

// ============================================
// COMPONENT
// ============================================
const OnlineRestaurents = () => {
    const { showLoader, hideLoader } = useLoader();
    const [restaurants, setRestaurants] = useState([]);
    const [filteredRestaurants, setFilteredRestaurants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchType, setSearchType] = useState('all');
    const [error, setError] = useState(null);

    // Search options
    const searchOptions = [
        { value: 'all', label: 'All Fields' },
        { value: 'registeredName', label: 'Restaurant Name' },
        { value: 'ownerName', label: 'Owner Name' },
        { value: 'vendorId', label: 'Vendor ID' },
        { value: 'city', label: 'City' }
    ];

    // ─── Fetch Restaurants ──────────────────────────────────────
    useEffect(() => {
        fetchRestaurants();
    }, []);

    const fetchRestaurants = async () => {
        try {
            setLoading(true);
            setError(null);
            showLoader();

            const token = localStorage.getItem('authToken');
            if (!token) {
                throw new Error('Authentication token not found');
            }

            const response = await fetch(API_URL, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch restaurants: ${response.status}`);
            }

            const data = await response.json();

            // Transform data to match our display format
            const transformedData = data.map(item => ({
                vendorId: item.vendorId,
                registeredName: item.registeredName || 'N/A',
                ownerName: item.ownerName || 'N/A',
                mobileNumber: item.mobileNumber || 'N/A',
                email: item.email || 'N/A',
                vendorType: item.vendorType || 'Restaurant',
                brandName: item.brandName || 'N/A',
                fullAddress: item.fullAddress || 'N/A',
                city: item.city || 'N/A',
                state: item.state || 'N/A',
                pincode: item.pincode || 'N/A',
                latitude: item.latitude,
                longitude: item.longitude,
                online: item.online || false,
                rating: item.rating || 0,
                orderTypes: item.orderTypes || [],
                approvalStatus: item.approvalStatus,
                companyLogo: item.companyLogo
            }));

            setRestaurants(transformedData);
            setFilteredRestaurants(transformedData);
            setLoading(false);
            hideLoader();

        } catch (error) {
            console.error('Error fetching restaurants:', error);
            setError(error.message || 'Failed to load restaurants');
            setLoading(false);
            hideLoader();
        }
    };

    // ─── Filter Restaurants ─────────────────────────────────────
    useEffect(() => {
        if (!searchQuery.trim()) {
            setFilteredRestaurants(restaurants);
            return;
        }

        const query = searchQuery.toLowerCase().trim();
        let filtered = restaurants.filter(restaurant => {
            switch (searchType) {
                case 'registeredName':
                    return restaurant.registeredName.toLowerCase().includes(query);
                case 'ownerName':
                    return restaurant.ownerName.toLowerCase().includes(query);
                case 'vendorId':
                    return restaurant.vendorId.toString().includes(query);
                case 'city':
                    return restaurant.city.toLowerCase().includes(query);
                default:
                    return restaurant.registeredName.toLowerCase().includes(query) ||
                        restaurant.ownerName.toLowerCase().includes(query) ||
                        restaurant.vendorId.toString().includes(query) ||
                        restaurant.city.toLowerCase().includes(query) ||
                        restaurant.brandName.toLowerCase().includes(query);
            }
        });

        setFilteredRestaurants(filtered);
    }, [searchQuery, searchType, restaurants]);

    // ─── Stats ──────────────────────────────────────────────────
    const totalRestaurants = filteredRestaurants.length;
    const totalCities = new Set(filteredRestaurants.map(r => r.city)).size;
    const totalTypes = new Set(filteredRestaurants.map(r => r.vendorType)).size;

    // ─── Format Date ────────────────────────────────────────────
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    // ─── Render ──────────────────────────────────────────────────
    if (loading) {
        return (
            <div style={styles.container}>
                <div style={styles.loadingOverlay}>
                    <div className="spinner" style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f4f6',
                        borderTop: '4px solid #e66d33',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 12px'
                    }}></div>
                    <p>Loading online restaurants...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={styles.container}>
                <div style={styles.emptyState}>
                    <p style={{ color: '#dc2626', fontWeight: '600' }}>⚠️ {error}</p>
                    <button
                        onClick={fetchRestaurants}
                        style={{
                            ...styles.actionBtn,
                            background: '#e66d33',
                            color: 'white',
                            marginTop: '12px'
                        }}
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            {/* ─── Dashboard Stats ────────────────────────────────── */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Online Restaurants</div>
                    <div style={styles.statValue}>{totalRestaurants}</div>
                    <div style={styles.statSub}>Currently online</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Cities</div>
                    <div style={{ ...styles.statValue, color: '#8b5cf6', }}>{totalCities}</div>
                    <div style={styles.statSub}>Total cities</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Vendor Types</div>
                    <div style={{ ...styles.statValue, color: '#0ea5e9' }}>{totalTypes}</div>
                    <div style={styles.statSub}>Unique types</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Avg Rating</div>
                    <div style={{ ...styles.statValue, color: '#f59e0b' }}>
                        {totalRestaurants > 0
                            ? (filteredRestaurants.reduce((sum, r) => sum + (r.rating || 0), 0) / totalRestaurants).toFixed(1)
                            : '0.0'}
                    </div>
                    <div style={styles.statSub}>Average rating</div>
                </div>
            </div>

            {/* ─── Filters Bar ────────────────────────────────────── */}
            <div style={styles.filtersBar}>
                <div style={styles.searchWrapper}>
                    <FaSearch color="#94a3b8" size={16} />
                    <select
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={styles.searchSelect}
                    >
                        {searchOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder={`Search by ${searchOptions.find(o => o.value === searchType)?.label || 'All Fields'}...`}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                        <span
                            style={{ cursor: 'pointer', color: '#94a3b8', padding: '4px' }}
                            onClick={() => setSearchQuery('')}
                        >
                            ✕
                        </span>
                    )}
                </div>



                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#e66d33',
                        color: 'white'
                    }}
                    onClick={fetchRestaurants}
                >
                    <FaSync size={14} /> Refresh
                </button>
            </div>

            {/* ─── Table ───────────────────────────────────────────── */}
            <div style={styles.tableWrapper}>
                {filteredRestaurants.length === 0 ? (
                    <div style={styles.emptyState}>
                        <div style={{ fontSize: '48px', marginBottom: '12px' }}>🏪</div>
                        <h3>No Online Restaurants Found</h3>
                        <p>
                            {restaurants.length === 0
                                ? 'No restaurants are currently online.'
                                : 'No restaurants match your search filters.'}
                        </p>
                    </div>
                ) : (
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>S.No</th>
                                <th style={styles.th}>Vendor ID</th>
                                <th style={styles.th}>Restaurant Name</th>
                                <th style={styles.th}>Owner Name</th>
                                <th style={styles.th}>Mobile</th>
                                <th style={styles.th}>Email</th>
                                <th style={styles.th}>Type</th>
                                <th style={styles.th}>Brand</th>
                                <th style={styles.th}>Address</th>
                                {/* <th style={styles.th}>Status</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRestaurants.map((restaurant, index) => (
                                <tr
                                    key={restaurant.vendorId}
                                    style={{
                                        transition: 'background 0.2s ease',
                                        borderBottom: '1px solid #f1f5f9'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#fef9f4'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                >
                                    <td style={styles.td}>{index + 1}</td>
                                    <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px', color: '#e66d33', fontWeight: '600' }}>
                                        {restaurant.vendorId}
                                    </td>
                                    <td style={{ ...styles.td, fontWeight: '600', color: '#1e293b' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: "150px", }}>
                                            <FaStore color="#e66d33" size={14} />
                                            {restaurant.registeredName}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: "150px" }}>
                                            <FaUser size={12} color="#94a3b8" />
                                            {restaurant.ownerName}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FaPhone size={12} color="#94a3b8" />
                                            {restaurant.mobileNumber}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FaEnvelope size={12} color="#94a3b8" />
                                            {restaurant.email}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{
                                            fontSize: '11px',
                                            padding: '2px 10px',
                                            borderRadius: '12px',
                                            background: '#e8f0fe',
                                            color: '#1a73e8'
                                        }}>
                                            {restaurant.vendorType}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FaBuilding size={12} color="#94a3b8" />
                                            {restaurant.brandName !== 'N/A' ? restaurant.brandName : '-'}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FaMapMarkerAlt size={12} color="#e66d33" />
                                            <span style={{ fontSize: '13px' }}>
                                                {restaurant.city}, {restaurant.state}
                                            </span>
                                        </div>
                                    </td>
                                    {/* <td style={styles.td}>
                                        <span style={styles.onlineBadge}>
                                            <span style={{ 
                                                display: 'inline-block', 
                                                width: '6px', 
                                                height: '6px', 
                                                borderRadius: '50%', 
                                                background: '#22c55e',
                                                marginRight: '6px',
                                                animation: 'pulse 1.5s ease-in-out infinite'
                                            }}></span>
                                            Online
                                        </span>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>


            {/* ─── Inline Styles ───────────────────────────────────── */}
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
                @keyframes pulse {
                    0% { opacity: 1; }
                    50% { opacity: 0.4; }
                    100% { opacity: 1; }
                }
                .spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid #f3f4f6;
                    border-top: 4px solid #e66d33;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin: 0 auto 12px;
                }
            `}</style>
        </div>
    );
};

export default OnlineRestaurents;